import { Injectable } from '@angular/core';
import { AccountService } from '@services/account.service';
import { PropertiesFormService } from '@ui-components/properties-form/properties-form.service';
import { PROPERTIES_FORM_NAME } from '@ui-components/properties-form/properties-form.config';
import { WTC_BOAT_SUBTIPES } from '@config/products.config';

@Injectable()
export class DynamicInputService {
  constructor(
    private accountService: AccountService,
    private propertiesFormService: PropertiesFormService
  ) {}

  handleAdditionalUpdateFormConfig(
    insideValue: any,
    propertyConfig: any,
    inputData,
    update,
    ofvBrandIdSelected,
    ofvModelIdSelected,
    ofvModelregYearSelected,
    ofvModelYearSelected,
  ): void {
    let additionalUpdateValueData: any = {};

    switch (propertyConfig.name) {
      case 'animalType': {
        additionalUpdateValueData = {
          value: insideValue,
          propertyToEditName: 'animalBreed',
          needSearchSelectComponentRefresh: true
        };

        if (propertyConfig.isAnimalUsageAreaCheck) {
          additionalUpdateValueData.isAnimalUsageAreaCheck = true;
        }

        update(additionalUpdateValueData);
        break;
      }
      case 'objectCategory': {
        const isListEmpty = propertyConfig.settings.list.find(x => x.value === insideValue).isListEmpty;

        additionalUpdateValueData = {
          value: insideValue,
          propertyToEditName: 'objectCategoryType',
          isListEmpty: isListEmpty
        };

        update(additionalUpdateValueData);
        break;
      }
      default: break;
    }

    if (this.accountService.getUser().isWtcFlow) {
      switch (propertyConfig.name) {
        case ('travelExclusive'): {
          additionalUpdateValueData = {
            value: insideValue,
            propertyToEditName: 'travelDuration'
          };

          update(additionalUpdateValueData);
          break;
        }
        case ('wtcBoatGroup'): {
          additionalUpdateValueData = {
            value: WTC_BOAT_SUBTIPES[insideValue.toUpperCase()],
            name: 'wtcBoatGroup',
            subTypeField: true
          };

          update(additionalUpdateValueData);
          break;
        }
        case ('wtcValuablesObjectType'): {
          const isSerialNumber = propertyConfig.settings.list.find(x => x.value === insideValue).isSerialNumber;
          additionalUpdateValueData = {
            value: insideValue,
            name: 'wtcValuablesObjectType',
            isSerialNumber: isSerialNumber
          };

          update(additionalUpdateValueData);
          break;
        }
        case ('boatMaxSpeed'): {
          const showBoatHightSpeedCertificate =
            propertyConfig.settings.list.find(x => x.value === insideValue).showBoatHightSpeedCertificate;

          if (showBoatHightSpeedCertificate || showBoatHightSpeedCertificate === false) {
            additionalUpdateValueData = {
              value: insideValue,
              name: 'boatMaxSpeed',
              showBoatHightSpeedCertificate: showBoatHightSpeedCertificate
            };

            update(additionalUpdateValueData);
          }
          break;
        }
        case ('animalChip'): {
          if (insideValue || insideValue === false) {
            additionalUpdateValueData = {
              value: insideValue,
              name: 'animalChip',
              isAnimalChip: insideValue
            };

            update(additionalUpdateValueData);
          }
          break;
        }
        default: break;
      }
    }

    if (propertyConfig.ofvVariantNeeded) {
      const regNumberPattern = new RegExp(propertyConfig.pattern);

      additionalUpdateValueData = {
        value: insideValue,
        ofvCarRegNumberValid: false
      };

      if (regNumberPattern.test(insideValue)) {
        additionalUpdateValueData.ofvCarRegNumberValid = true;
      }

      update(additionalUpdateValueData);
    }

    if (propertyConfig.isRentalPropertiesCheck) {
      additionalUpdateValueData = {
        value: insideValue,
        name: propertyConfig.name,
        isRentalPropertiesCheck: true
      };

      update(additionalUpdateValueData);
    }

    if (propertyConfig.isHouseDamagesCheck) {
      additionalUpdateValueData = {
        value: insideValue,
        name: propertyConfig.name,
        isHouseDamagesCheck: true
      };

      update(additionalUpdateValueData);
    }

    if (propertyConfig.isElectricBicycleCoverageCheck) {
      additionalUpdateValueData = {
        value: insideValue,
        name: propertyConfig.name,
        isElectricBicycleCoverageCheck: true
      };

      update(additionalUpdateValueData);
    }

    if (propertyConfig.isStormAnimalIdCheck) {
      additionalUpdateValueData = {
        value: insideValue,
        name: propertyConfig.name,
        isStormAnimalIdCheck: true
      };

      update(additionalUpdateValueData);
    }

    if (propertyConfig.isStormAnimalDeathSumCheck) {
      additionalUpdateValueData = {
        value: insideValue,
        name: propertyConfig.name,
        isStormAnimalDeathSumCheck: true
      };

      update(additionalUpdateValueData);
    }

    if (propertyConfig.isStormAnimalBreedCheck) {
      additionalUpdateValueData = {
        value: insideValue,
        name: propertyConfig.name,
        isStormAnimalBreedCheck: true
      };

      update(additionalUpdateValueData);
    }

    if (propertyConfig.isStormTravelNumberOfInsuredPersonsCheck) {
      additionalUpdateValueData = {
        value: insideValue,
        name: propertyConfig.name,
        isStormTravelNumberOfInsuredPersonsCheck: true
      };

      update(additionalUpdateValueData);
    }

    if (propertyConfig.isStormValuablesObjectCountCheck) {
      additionalUpdateValueData = {
        value: insideValue,
        name: propertyConfig.name,
        isStormValuablesObjectCountCheck: true
      };

      update(additionalUpdateValueData);
    }

    if (propertyConfig.isStormBicycleCoverageCheck) {
      additionalUpdateValueData = {
        value: insideValue,
        name: propertyConfig.name,
        isStormBicycleCoverageCheck: true
      };

      update(additionalUpdateValueData);
    }

    if (propertyConfig.isIncludeExtendedSumFixedEquipmentCheck) {
      additionalUpdateValueData = {
        value: insideValue,
        name: propertyConfig.name,
        isIncludeExtendedSumFixedEquipmentCheck: true
      };

      update(additionalUpdateValueData);
    }

    if (propertyConfig.isIncludeExtendedSumMovablesCheck) {
      additionalUpdateValueData = {
        value: insideValue,
        name: propertyConfig.name,
        isIncludeExtendedSumMovablesCheck: true
      };

      update(additionalUpdateValueData);
    }

    if (propertyConfig.isAnimalDeathCoverageCheck) {
      additionalUpdateValueData = {
        value: insideValue,
        name: propertyConfig.name,
        isAnimalDeathCoverageCheck: true
      };

      update(additionalUpdateValueData);
    }

    if (propertyConfig.isDriverBirthYearCheck) {
      additionalUpdateValueData = {
        value: insideValue,
        name: propertyConfig.name,
        isDriverBirthYearCheck: true
      };

      update(additionalUpdateValueData);
    }

    if (propertyConfig.isWtcBoatMotorInsuranceCheck) {
      additionalUpdateValueData = {
        value: insideValue,
        name: propertyConfig.name,
        isWtcBoatMotorInsuranceCheck: true
      };

      update(additionalUpdateValueData);
    }

    if (propertyConfig.isKolibriProductPackageCheck) {
      additionalUpdateValueData = {
        value: insideValue,
        name: propertyConfig.name,
        isKolibriProductPackageCheck: true
      };

      update(additionalUpdateValueData);
    }

    if (propertyConfig.isWtcBoatBoatDamageCheck) {
      additionalUpdateValueData = {
        value: insideValue,
        name: propertyConfig.name,
        isWtcBoatBoatDamageCheck: true
      };

      update(additionalUpdateValueData);
    }

    if (propertyConfig.isBoatSecuremarkCheck) {
      additionalUpdateValueData = {
        value: insideValue,
        name: propertyConfig.name,
        isBoatSecuremarkCheck: true
      };

      update(additionalUpdateValueData);
    }

    if (propertyConfig.isBoatSecuremarkCheckKLP) {
      additionalUpdateValueData = {
        value: insideValue,
        name: propertyConfig.name,
        isBoatSecuremarkCheckKLP: true
      };

      update(additionalUpdateValueData);
    }

    if (propertyConfig.isLicenceNumberAvailabilityCheck) {
      additionalUpdateValueData = {
        value: insideValue,
        name: propertyConfig.name,
        isLicenceNumberAvailabilityCheck: true
      };

      update(additionalUpdateValueData);
    }

    if (propertyConfig.isRentalPeriodCheck) {
      additionalUpdateValueData = {
        value: insideValue,
        name: propertyConfig.name,
        isRentalPeriodCheck: true
      };

      update(additionalUpdateValueData);
    }

    if (propertyConfig.isContinuedHealthInsuranceCheck) {
      additionalUpdateValueData = {
        value: insideValue,
        name: propertyConfig.name,
        isContinuedHealthInsuranceCheck: true
      };

      update(additionalUpdateValueData);
    }

    if (propertyConfig.isLisingCheck) {
      additionalUpdateValueData = {
        value: insideValue,
        name: propertyConfig.name,
        isLisingCheck: true
      };

      update(additionalUpdateValueData);
    }

    if (propertyConfig.isBoatHasMotorCheck) {
      additionalUpdateValueData = {
        value: insideValue,
        name: propertyConfig.name,
        isBoatHasMotorCheck: true
      };

      update(additionalUpdateValueData);
    }

    if (propertyConfig.isDriverAndPassengerCheck) {
      additionalUpdateValueData = {
        value: insideValue,
        name: propertyConfig.name,
        isDriverAndPassengerCheck: true
      };

      update(additionalUpdateValueData);
    }

    if (propertyConfig.isFirstRiskSumInsuredCheck) {
      additionalUpdateValueData = {
        value: insideValue,
        name: propertyConfig.name,
        key: propertyConfig.key,
        index: inputData.index,
        propertyArrayName: inputData.propertyArrayName,
        formArrayKeyName: inputData.propertyArrayName ?
          `${inputData.propertyArrayName}_${inputData.index}` : PROPERTIES_FORM_NAME,
        isFirstRiskSumInsuredCheck: true
      };

      update(additionalUpdateValueData);
    }


    if (this.accountService.getUser().isWtcFlow) {
      if (propertyConfig.isOfvBrandId) {
        this.propertiesFormService.ofvCarData.carBrandId = insideValue;
        ofvBrandIdSelected();
      }

      if (propertyConfig.isOfvModelId) {
        this.propertiesFormService.ofvCarData.carModelId = insideValue;
        ofvModelIdSelected();
      }

      if (propertyConfig.isOfvModelRegYear) {
        this.propertiesFormService.ofvCarData.carRegModelYear = insideValue;
        ofvModelregYearSelected();
      }

      if (propertyConfig.isOfvModelYear) {
        this.propertiesFormService.ofvCarData.carModelYear = insideValue;
        ofvModelYearSelected();
      }

      if (propertyConfig.isOfvVariantId) {
        this.propertiesFormService.ofvCarData.carVariantId = insideValue;
      }
    }
  }
}
